import React from 'react'
import { useHistory } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import Checkbox from '@material-ui/core/Checkbox'
import useBuildingsApi from '../../hooks/buildings/useBuildingsApi'
import { userTypes } from '../../utils/constants'
import CustomTable from '../customTable/CustomTable'
import cookies from '../../utils/cookies'
import ListHeader from '../common/ListHeader'

export default function BuildingList() {
  const history = useHistory()
  const classes = useStyles()

  const [state, methods] = useBuildingsApi()
  const getLoggedUser = () => {
    try {
      const user = cookies.get('user')
      return JSON.parse(user)
    } catch (e) {
      return null
    }
  }
  const loggedUser = getLoggedUser()

  const columns = [
    { id: 'name', label: 'Nombre', minWidth: 170 },
    { id: 'sipURL', label: 'Url Central SIP', minWidth: 100 },
    {
      id: 'wssURL',
      label: 'Url WSS',
      minWidth: 100,
    },
    {
      id: 'sipSOS',
      label: 'Interno SIP SOS',
      minWidth: 100,
    },
    {
      id: 'doorbellURL',
      label: 'Url Portero',
      minWidth: 100,
    },
    {
      id: 'requiredImage',
      label: 'Foto requerida',
      minWidth: 120,
      order: 7,
      format: (building) => (
        <Checkbox
          checked={building.requiredImage}
          color="primary"
          inputProps={{
            'aria-label': 'secondary checkbox',
          }}
          disabled
          className={classes.checkbox}
        />
      ),
    },
    {
      ...(loggedUser?.type === userTypes.admin && {
        id: '',
        label: '',
        minWidth: 5,
      }),
    },
  ]

  const options = (building) => [
    {
      key: 'edit',
      label: 'Editar',
      onClick: () => {
        history.push('nuevo-edificio', { building })
      },
    },
    {
      key: 'updateImages',
      label: 'Actualizar imagenes porteros',
      onClick: () => {
        methods.updateImages(building.id)
      },
    },
    {
      key: 'delete',
      label: 'Eliminar',
      onClick: () => {
        methods.deleteBuilding(building.id)
      },
    },
  ]

  const buildings = state.buildingsState.buildings

  return (
    <>
      <ListHeader
        bigTitle="Edificios"
        canCreate={loggedUser?.type === userTypes.admin}
        createText="Nuevo edificio"
        createRedirect={() => history.push('nuevo-edificio')}
      />
      <CustomTable
        loading={state.buildingsState.isLoading}
        columns={columns}
        data={buildings || []}
        getData={(params) => {
          methods.getBuildings(true, { ...params })
        }}
        buildingFilter={false}
        building={false}
        apartmentFilter={false}
        searchFilter={'Nombre, o SIP URL'}
        searchTitle='Nombre, o SIP URL'
        searchPlaceholder='Nombre, o SIP URL'
        options={options}
        serverPagination={false}
        serverCount={state.buildingsState.count}
        handleRowClick={(building) => history.push(`/edificios/${building.id}`)}
      ></CustomTable>
    </>
  )
}

const useStyles = makeStyles({
  root: {
    width: '100%',
  },
  checkbox: {
    marginLeft: '8px',
  },
  searchWrapper: {
    width: '267px',
    margin: '20px 0',
  },
})
